export const BRAND_NAME = 'Sky11Bet';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'sky11bet.com';
export const PROVIDER_ID = 'BetFair';
